/** Draft-only AI assistance client (URS-MBR-014, URS-EXC-010, URS-CTL-045). No zod: the server validates. */
import { api } from "./api.js";

export type AiKind = "MBR_DRAFT" | "DEVIATION_TRIAGE" | "CONTROL_DRAFT";

export interface AiStatus {
  configured: boolean;
  enabled: boolean;
  engaged: boolean;
  switch: { engaged: boolean; reason: string; at: string; by: string } | null;
  provider: "openai" | "stub" | null;
  modelId: string | null;
  sendsDataOffSite: boolean;
  label: string;
}

export interface AiReview {
  decision: "ACCEPTED" | "EDITED" | "REJECTED";
  reason: string;
  reviewer: string;
  at: string;
  finalHash: string | null;
  resultRef: string | null;
}

export interface AiOutput {
  id: string;
  kind: AiKind;
  modelId: string;
  promptHash: string;
  outputHash: string;
  subjectId: string | null;
  createdAt: string;
  requestedBy: string;
  label: string;
  output: unknown;
  review: AiReview | null;
}

export interface ReviewBody {
  decision: "ACCEPTED" | "EDITED" | "REJECTED";
  reason: string;
  edited?: unknown;
  templateCode?: string;
  name?: string;
  market?: string;
}

const P = "/api/v1/ai";

export const aiApi = {
  status: () => api.get<AiStatus>(`${P}/status`),
  setSwitch: (engaged: boolean, reason: string) => api.post<AiStatus>(`${P}/switch`, { engaged, reason }),
  mbrDraft: (text: string) => api.post<AiOutput>(`${P}/mbr/draft`, { text }),
  controlDraft: (text: string) => api.post<AiOutput>(`${P}/control/draft`, { text }),
  deviations: () =>
    api.get<{ id: string; deviationNumber: string; title: string; classification: string }[]>(
      `${P}/deviations`,
    ),
  triage: (deviationId: string) => api.post<AiOutput>(`${P}/deviations/${deviationId}/triage`, {}),
  outputs: () => api.get<AiOutput[]>(`${P}/outputs`),
  review: (id: string, b: ReviewBody) => api.post<AiOutput>(`${P}/outputs/${id}/review`, b),
};
